var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRtf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.468 17.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(7865.213 -3940.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_907_",
    d: "M97.568,48.839H86.994A1.293,1.293,0,0,1,85.7,47.544V32.794A1.293,1.293,0,0,1,86.994,31.5H97.568a1.293,1.293,0,0,1,1.294,1.294v14.75A1.293,1.293,0,0,1,97.568,48.839Z",
    transform: "translate(-7950.913 3909.798)",
    fill: "#22a790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_906_",
    d: "M98.8,59.66V45.282a.98.98,0,0,1,.982-.982h10.171a.98.98,0,0,1,.982.982V59.66a.98.98,0,0,1-.982.981H99.782A.985.985,0,0,1,98.8,59.66Z",
    transform: "translate(-7963.5 3897.498)",
    fill: "#37d8bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    d: "M198.716,30.366V26.471L193.3,21.2h-4Z",
    transform: "translate(-8050.461 3919.695)",
    fill: "#1d8876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_904_",
    d: "M189.3,21.2v.4h.415Z",
    transform: "translate(-8050.461 3919.695)",
    fill: "#096047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    d: "M422.3,248v.3h.3Z",
    transform: "translate(-8274.351 3701.764)",
    fill: "#096047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M-2.178-1.094h-.551V0h-.494V-2.844h1a1.163,1.163,0,0,1,.76.221.781.781,0,0,1,.268.639.8.8,0,0,1-.138.478.876.876,0,0,1-.384.3l.639,1.184V0h-.529Zm-.551-.4h.508a.565.565,0,0,0,.391-.126.439.439,0,0,0,.141-.345.468.468,0,0,0-.13-.354.552.552,0,0,0-.388-.129h-.521ZM1.23-2.445H.344V0h-.49V-2.445h-.879v-.4H1.23Zm2.012,1.24H2.1V0H1.6V-2.844H3.41v.4H2.1V-1.6H3.242Z",
    transform: "translate(-7858.478 3955)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.304bb84bed306df1741b93ff02103e84.svg";
export { ForwardRef as ReactComponent };